import React from 'react';

export type DeskLegendItem = {
  swatch: string,
  label: string,
};

type Props = {
  items: Array<DeskLegendItem>,
};

const DeskLegend = (props: Props): React.ReactElement => {
  const { items } = props;

  return (
    <div className="desk-legend">
      {items.map(({ swatch, label }) => (
        <span key={swatch}><i className={`desk-legend__swatch desk-legend__swatch--${swatch}`} /> {label}</span>
      ))}
    </div>
  );
};

export default DeskLegend;
